import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { PRODUCT_SUBTITLE } from './salesData';

/** Cierre: la consulta ya llegó, ahora hay que convertirla. */
export function FinalCta() {
  return <section className="w-full bg-ink py-16 text-white sm:py-20" data-id="element-64" data-mp="19gihj2mgvh3f">
      <div className="mx-auto w-full max-w-3xl px-5 text-center sm:px-6" data-id="element-65" data-mp="15d41ibyj30pz">
        <h2 className="font-display text-[2rem] font-extrabold leading-[1.1] sm:text-[2.7rem]" data-id="element-66" data-mp="1jd4znjneru1r">
          La consulta ya llegó.
          <br data-id="element-67" data-mp="1eetpt8x45jjj" />
          <span className="mark-green" data-id="element-68" data-mp="1ed8z5udx6kqy">Ahora hay que cerrarla.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-sans text-[1.02rem] leading-relaxed text-white/65" data-id="element-69" data-mp="1t37u7oa6hg27">
          {PRODUCT_SUBTITLE}
        </p>

        <PriceBlock className="mt-8" size="lg" tone="dark" data-id="element-70" data-mp="1o5y7whi35kil" />
        <CTAButton className="mt-6 w-full sm:w-auto" label="QUIERO LOS 100 SCRIPTS" data-id="element-71" data-mp="224o4zx4wnk6y" />
        <p className="mt-3 font-sans text-[0.78rem] text-white/45" data-id="element-72" data-mp="1x5b6gf4o8ooj">
          Acceso inmediato después de la compra · 100% digital
        </p>
      </div>
    </section>;
}